<app-segov-sigepo-portal-body>
  <app-segov-sigepo-header-section [Title]="title"
    [RouteStack]="RouteStack">
  </app-segov-sigepo-header-section>

  <h3 class="exibe-tela-maior-993 default-spacing-title titulo-pagina-servico" style="color: var(--tom-2-informativo);">{{tituloPagina}}</h3>

  <div class="default-spacing-title conteudo-fixo-servico row">
    <div class="col-lg-8 col-12 remover-padding-tela-pequena" style="padding-bottom: 1.5rem">
      @switch(menuSelecionado){
        @case("Publicação no jornal"){
          <app-publicacao-de-materia/>
        }
        @case("Consulta ao acervo do jornal") {
          <app-consulta/>
        }
        @case("Ressarcimento de Valores") {
          <app-ressarcimento-de-valores/>
        }
        @case("Gratuidade de Publicação") {
          <app-gratuidade-de-publicacao/>
        }
      }
    </div>

    <h3 class="exibe-tela-menor-993" style="color: var(--tom-2-informativo);">{{tituloPagina}}</h3>

    <div class="col-lg-4 col-12 remover-padding-tela-pequena nossos-servicos">
      <h4 style="color: var(--tom-2-informativo); text-align: right;">Nossos serviços</h4>
      <app-menu-lateral
      [style.width]="'100%'"
      [items]="servicosMenu"
      [defaultValue]="menuSelecionado"
      [itemSelected]="menuSelecionado"
      (itemSelectedChange)="obterMenuSelecionado($event)"/>

      <button
      class="calendario-de-publicacao-button"
      (click)="goToCalendario()"
      >
        <img src="icons/bx-calendar.svg" alt="Calendário" width="30"/> Calendário de Publicação
      </button>
    </div>
  </div>


  <div class="conteudo-servico mb-5" style="padding-top: 1rem; ">
    <app-listar-topicos-servico
      [servicoSelecionado]="menuSelecionado"
      [accordeonsExpandidos]="verTodos"/>
  </div>

</app-segov-sigepo-portal-body>
